import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface ResultItemProps {
  withDivider?: boolean
}

export const ResultHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S16};
  font-variant-numeric: tabular-nums;
`

export const ResultItem = styled.div<ResultItemProps>`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: ${Spacing.S4} ${Spacing.S6};

  ${({ withDivider }) =>
    withDivider &&
    `
    padding-left: ${Spacing.S12};
    border-left: 1px solid ${Color.Grey200};
  `}
`
